import { startupsUrl } from '@src/lib/startups-url'
import { usePathname, useSearchParams } from 'next/navigation'

export const useCurrentUrl = (modifications?: { newPathname?: string; params?: any }) => {
  const pathname = usePathname()
  const params = useSearchParams()

  const paramsObj = {}
  params.forEach((value, key) => (paramsObj[key] = value))
  Object.keys(modifications?.params || {}).forEach(key => {
    paramsObj[key] = modifications?.params[key]
  })

  return startupsUrl(modifications?.newPathname || pathname, paramsObj)
}
